import React, { useState } from 'react';

const Textarea = ({ 
  label,
  error,
  helperText,
  size = 'md',
  variant = 'default',
  className = '',
  ...props 
}) => {
  const [focused, setFocused] = useState(false);

  const baseStyles = {
    width: '100%',
    fontFamily: 'var(--font-family)',
    fontSize: 'var(--font-size-base)',
    lineHeight: 'var(--line-height-normal)',
    color: 'var(--color-gray-900)',
    backgroundColor: 'var(--bg-primary)',
    border: `1px solid ${error ? 'var(--color-error)' : focused ? 'var(--color-primary)' : 'var(--color-gray-300)'}`,
    borderRadius: 'var(--radius-md)',
    transition: 'all var(--transition-fast)',
    outline: 'none',
    boxShadow: focused ? '0 0 0 3px rgba(13, 116, 99, 0.1)' : 'none',
    resize: 'vertical'
  };

  const sizes = {
    sm: {
      padding: 'var(--space-2) var(--space-3)',
      fontSize: 'var(--font-size-sm)',
      minHeight: '80px'
    },
    md: {
      padding: 'var(--space-3) var(--space-4)',
      fontSize: 'var(--font-size-base)',
      minHeight: '100px'
    },
    lg: {
      padding: 'var(--space-4) var(--space-5)',
      fontSize: 'var(--font-size-lg)',
      minHeight: '120px'
    }
  };

  const variants = {
    default: {
      ...baseStyles,
      ...sizes[size]
    },
    filled: {
      ...baseStyles,
      ...sizes[size],
      backgroundColor: 'var(--color-gray-50)',
      borderColor: 'transparent',
      '&:focus': {
        backgroundColor: 'var(--bg-primary)',
        borderColor: 'var(--color-primary)'
      }
    }
  };

  const textareaStyles = {
    ...variants[variant],
    ...props.style
  };

  return (
    <div className={className} style={{ width: '100%' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: 'var(--font-size-sm)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--color-gray-700)',
          marginBottom: 'var(--space-2)'
        }}>
          {label}
        </label>
      )}
      
      <textarea
        {...props}
        style={textareaStyles}
        onFocus={(e) => {
          setFocused(true);
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          props.onBlur?.(e);
        }}
      />
      
      {(error || helperText) && (
        <div style={{
          marginTop: 'var(--space-1)',
          fontSize: 'var(--font-size-sm)',
          color: error ? 'var(--color-error)' : 'var(--color-gray-500)'
        }}>
          {error || helperText}
        </div>
      )}
    </div>
  );
};

export default Textarea;
